export default function FunnelChart({ steps }) {
  const maxValue = Math.max(...steps.map((s) => s.value), 1);

  return (
    <div className="space-y-3">
      {steps.map((s, i) => {
        const pct = (s.value / maxValue) * 100;
        const convRate = i > 0 && steps[i - 1].value > 0 ? (s.value / steps[i - 1].value) * 100 : null;
        return (
          <div key={s.label}>
            <div className="flex justify-between text-xs text-gray-600 mb-1">
              <span className="font-medium">{s.label}</span>
              <span>
                {s.value.toLocaleString()}
                {convRate != null && <span className="ml-2 text-gray-400">({convRate.toFixed(1)}%)</span>}
              </span>
            </div>
            <div className="h-6 bg-gray-100 rounded overflow-hidden">
              <div
                className="h-full bg-blue-600 transition-all"
                style={{ width: `${pct}%`, background: '#1A6EFF' }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
